import {useState} from "react";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import {TABLES} from "../../../../Apis/Tables";

/**
 * List of the guards step, paged and searched by name, email or phone. On the creation it lists the
 * available guards; on the update it is shared by the add and the assigned tabs, as the devices do,
 * so only the tab shown reads it.
 */
const GuardStepApp = (zoneAccessId) => {
    const [guardResults, setGuardResults] = useState(null);
    const [guardSearchElement, setGuardSearchElement] = useState('');
    const [guardModified, setGuardModified] = useState(false);
    const [, setGuardSearch] = useState(false);
    const [, setGuardSimpleSearch] = useState(false);
    const [, setGuardBodyForExport] = useState(null);

    /**
     * Request of a page of the available guards, searched by name, email or phone. On the update the
     * guards already in the zone access are left out.
     */
    const guardTableBuildBody = ({page, rowsPerPage, searchElement}) => ({
        body: SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: TABLES.ZONE_ACCESS_AVAILABLE_GUARD,
            key: searchElement,
            modelId: zoneAccessId,
        }),
    });

    return {
        guardResults,
        setGuardResults,
        guardSearchElement,
        setGuardSearchElement,
        setGuardSearch,
        setGuardSimpleSearch,
        setGuardBodyForExport,
        guardModified,
        setGuardModified,
        guardTableBuildBody,
    };
};

export default GuardStepApp;
